var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpandedMinus(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.729 0 0 6.729 0 15s6.729 15 15 15 15-6.73 15-15S23.271 0 15 0zm0 27.676C8.011 27.676 2.324 21.99 2.324 15S8.01 2.324 15 2.324 27.676 8.01 27.676 15 21.99 27.676 15 27.676z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 12,
    height: 2,
    rx: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedMinus);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg%3e %3cpath d='M15 0C6.7285 0 0 6.7285 0 15C0 23.2715 6.7285 30 15 30C23.2715 30 30 23.2703 30 15C30 6.72967 23.2715 0 15 0ZM15 27.6762C8.01123 27.6762 2.32377 21.9899 2.32377 15C2.32377 8.01006 8.01123 2.32377 15 2.32377C21.9888 2.32377 27.6762 8.01006 27.6762 15C27.6762 21.9899 21.9899 27.6762 15 27.6762Z'/%3e %3crect x='9' y='14' width='12' height='2' rx='1'/%3e %3c/g%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };